//export const BASE_API = 'http://192.168.0.4:3333/'; //LOCALHOST JOSI;
export const BASE_API = 'https://warehouse-icct.herokuapp.com/'; //ONLINE JUNIOR;

//USERS
export const LIST_USER = 'user/list';
export const DELETE_USER = 'user/delete/';
export const ADD_EMPLOYEE = 'employee/register';
export const CHECK_EMAIL = 'employee/validate/email';
export const USER_LOGIN = 'user/login';
export const FORGOT_PASSWORD = 'user/send/token';
export const RESET_PASSWORD = 'user/edit/password/';
export const VALIDATE_TOKE = 'user/validate/token';

//PLANTS
export const LIST_PLANT = 'plant/list';
export const ADD_PLANT = 'plant/register';
export const UPDATE_PLANT = 'plant/edit/';
export const DELETE_PLANT = 'plant/delete/';

//WAREHOUSE
export const LIST_WAREHOUSE = 'warehouse/list';
export const ADD_WAREHOUSE = 'warehouse/register';
export const UPDATE_WAREHOUSE = 'warehouse/edit/';
export const DELETE_WAREHOUSE = 'warehouse/delete/';

//CORRIDOR
export const LIST_CORRIDOR = 'corridor/list';
export const ADD_CORRIDOR = 'corridor/register';
export const UPDATE_CORRIDOR = 'corridor/edit/';
export const DELETE_CORRIDOR = 'corridor/delete/';

//CABINET
export const LIST_CABINET = 'cabinet/list';
export const ADD_CABINET = 'cabinet/register';
export const UPDATE_CABINET = 'cabinet/edit/';
export const DELETE_CABINET = 'cabinet/delete/';

//SHELF
export const LIST_SHELF = 'shelf/list';
export const ADD_SHELF = 'shelf/register';
export const UPDATE_SHELF = 'shelf/edit/';
export const DELETE_SHELF = 'shelf/delete/';

//PALLET
export const LIST_PALLET = 'pallet/list';
export const ADD_PALLET = 'pallet/register';
export const UPDATE_PALLET = 'pallet/edit/';
export const DELETE_PALLET = 'pallet/delete/';

//BOX
export const LIST_BOX = 'box/list';
export const ADD_BOX = 'box/register';
export const UPDATE_BOX = 'box/edit/';
export const DELETE_BOX = 'box/delete/';

//DEPARTMENT
export const LIST_DEPARTMENT = 'department/list';
export const ADD_DEPARTMENT = 'department/register';
export const UPDATE_DEPARTMENT = 'department/edit/';
export const DELETE_DEPARTMENT = 'department/delete/';

//COST CENTER
export const LIST_COSTCENTER = 'costcenter/list';
export const ADD_COSTCENTER = 'costcenter/register';
export const UPDATE_COSTCENTER = 'costcenter/edit/';
export const DELETE_COSTCENTER = 'costcenter/delete/';

//COST CENTER
export const LIST_PURCHASINGSECTOR = 'purchasingsector/list';
export const ADD_PURCHASINGSECTOR = 'purchasingsector/register';
export const UPDATE_PURCHASINGSECTOR = 'purchasingsector/edit/';
export const DELETE_PURCHASINGSECTOR = 'purchasingsector/delete/';

//function
export const LIST_FUNCTION = 'function/list';
export const ADD_FUNCTION = 'function/register';
export const UPDATE_FUNCTION = 'function/edit/';
export const DELETE_FUNCTION = 'function/delete/';